import { Component, Input, Output, EventEmitter, ElementRef, HostListener, OnChanges, OnInit } from '@angular/core';
import { IFilter } from 'app/shared/interfaces/IFilter';
import { IFilterOption } from 'app/shared/interfaces/IFilterOption';
import { IFilterSelected } from 'app/shared/interfaces/IFilterSelected';
import { IFilterSelectedItem } from 'app/shared/interfaces/IFilterSelectedItem';

@Component({
  selector: 'bz-filter',
  templateUrl: './filter.html',
  styleUrls: ['./filter.css']
})
export class FilterComponent implements OnInit {
  @Input() configuration: IFilter[] = [];
  @Output() change = new EventEmitter<IFilterSelected[]>();

  private initialConfiguration: IFilter[] = [];
  isOpen = false;
  filterApplied: boolean = false;

  constructor(private eRef: ElementRef) { }
  ngOnInit() {    
    // Clonar solo cuando configuration cambia y aún no tenemos una copia inicial
    if (this.configuration.length && !this.initialConfiguration.length) {
      this.initialConfiguration = JSON.parse(JSON.stringify(this.configuration));
    }
  }

  // Abre / Cierra el panel
  togglePanel() {
    this.isOpen = !this.isOpen;
  }

  // Seleccionar una opción tipo radio dentro de un grupo
  selectOption(group: IFilter, option: IFilterOption) {
    group.options.forEach((o: IFilterOption) => (o.selected = false));
    option.selected = true;

    this.emitSelected();
  }
  // Detectar clic fuera del componente
  @HostListener('document:click', ['$event'])
  onClickOutside(event: any) {
    if (this.isOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  emitSelected() {
    const result = this.configuration.map(group => ({
      id: group.id,
      text: group.text,
      type: group.type,
      selected: group.options
        .filter((opt: IFilterOption) => opt.selected)
        .map((opt: IFilterSelectedItem) => ({
          text: opt.text,
          value: opt.value
        }))
    })) as IFilterSelected[];

    this.filterApplied = this.wasFilterApplied(result);

    this.change.emit(result);
  }
  wasFilterApplied(filterSelected: IFilterSelected[]): boolean {
    for (const group of this.initialConfiguration) {
      const defaultSelected = group.options.filter(o => o.selected).map(o => o.value);
      const selectedGroup = filterSelected.find(f => f.id === group.id);
      const currentSelected = selectedGroup?.selected.map(s => s.value) ?? [];
      const changed =
        defaultSelected.length !== currentSelected.length ||
        defaultSelected.some(val => !currentSelected.includes(val));
      if (changed) {
        return true;
      }
    }
    return false;
  }
}
